// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General container setup */
body {
    margin: 0;
    padding-top: 160px;
    background: linear-gradient(to bottom, black, #126196);
    color: #6C757D;
    font-family: Arial, sans-serif;
    padding-left: 130px;
    padding-right: 130px;
    margin-top: 50px;
  }
  
  h1 {
    font-size: 2.5rem;
    color: #01B9F1;
    text-align: center;
  }
  
  .error-message {
    background-color: rgba(255, 0, 0, 0.2);
    color: red;
    padding: 10px;
    border-radius: 5px;
    text-align: center;
    margin-top: 10px;
  }
  
  .form-select, 
  .form-input {
    background-color: #f8f9fa;
    color: #000;
    border: none;
    padding: 10px;
    font-size: 1rem;
    border-radius: 5px;
  }
  
  .form-select {
    width: 200px;
    margin-right: 10px;
  }
  
  .form-input {
    width: 800px;
    margin-right: 10px;
  }
  
  .form-button {
    background-color: #01B9F1;
    color: white;
    border: none;
    padding: 10px 20px;
    font-size: 1.2rem;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .form-button:hover {
    background-color: #0288d1;
  }
  
  .spinner-border {
    width: 3rem;
    height: 3rem;
    border-width: 0.3rem;
    color: #01B9F1;
  }
  
  .card {
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  }
  
  .card textarea {
    background-color: rgba(1, 1, 1, 0.5);
    color: white;
    width: 100%;
    height: 250px;
    border: none;
    padding: 10px;
    border-radius: 10px;
    resize: none;
  }
  
  .card-title {
    font-size: 1.5rem;
    margin-bottom: 10px;
  }
  
  .copy-btn {
    background-color: #6c757d;
    color: white;
    border: none;
    padding: 5px 10px;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .copy-btn:hover {
    background-color: #5a6268;
  }
  
  .vote-btn {
    background-color: #01B9F1;
    color: white;
    border: none;
    padding: 10px 20px;
    font-size: 1.2rem;
    margin: 5px;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .vote-btn:hover {
    background-color: #0288d1;
  }
  
  .reset-btn {
    background-color: #6c757d;
    color: white;
    border: none;
    padding: 10px 20px;
    font-size: 1.2rem;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .reset-btn:hover {
    background-color: #5a6268;
  }
  
  .button {
    background-color: #01B9F1; 
    color: white;
    border: none;
    border-radius: 5px;
    padding: 10px 20px;
    font-size: large;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.2s ease;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  }
  
  .button-vote{
    border: 2px solid #01B9F1;
    color: #01B9F1;
    margin-bottom: 100px;
  }
  
  .button-vote:hover{
    background-color: #019FCB;
    transform: scale(1.05); 
    border: 2px solid #019FCB;
  }
  
  .button:hover {
    background-color: #019FCB; 
    transform: scale(1.05);
  }
  
  .button:active {
    background-color: #017A9B; 
    transform: scale(0.98);
  }
  
  .query {
    display: flex;
    justify-content: center;
    margin-top: auto;
  }
  
  .query input {
    width: 100%;
    max-width: 1200px;
    padding: 12px 20px;
    font-size: large;
    color: white;
    background-color: rgba(0, 0, 0, 0); 
    border: 2px solid #01B9F1; 
    border-radius: 8px;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
    outline: none;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  }
  
  .query input::placeholder {
    color: rgba(255, 255, 255, 0.7); 
  }
  
  .query input:focus {
    border-color: #019FCB; 
    box-shadow: 0 0 10px rgba(1, 185, 241, 0.6); 
  }
  
  .query input:disabled {
    background-color: rgba(0, 0, 0, 0.2);
    color: #6C757D;
    cursor: not-allowed;
  }
  
  .dropdown select {
    width: 200px;
    max-width: auto;
    padding: 10px;
    font-size: large;
    color: white; 
    background-color: rgba(0, 0, 0, 0);
    border: 2px solid #01B9F1;
    border-radius: 8px;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
    outline: none;
    appearance: none;
    box-shadow: none;
    cursor: pointer;    
  }
  
  .dropdown select:focus {
    border-color: #019FCB;
    box-shadow: 0 0 5px rgba(1, 185, 241, 0.4);
  }
  
  .dropdown select option {
    background-color: rgba(0, 0, 0, 0.8); 
    color: white; 
  }
  
  .dropdown select option[disabled] {
    color: #6C757D; 
  }
  
  .dropdown select:disabled {
    background-color: rgba(0, 0, 0, 0.2);
    color: #6C757D;
    cursor: not-allowed;
  }
  
  /* Responsive Styles */
  @media (max-width: 1200px) {
    body {
      padding-left: 50px;
      padding-right: 50px;
      margin-bottom: 100px;
    }
  
    .form-input {
      width: 100%;
    }
  
    .form-select {
      width: 100%;
    }
  
    .card textarea {
      height: 400px;
    }

    .button-vote {
        margin-bottom: 100px;
    }
  }
  
  @media (max-width: 768px) {
    body {
      padding-left: 30px;
      padding-right: 30px;
      padding-top: 250px;
      margin-bottom: 100px;
    }
  
    h1 {
      font-size: 2rem;
    }
  
    .query {
        flex-direction: row; 
    }
    
    .query input {
        max-width: 800px;
    }
    
    .dropdown select {
        max-width: 120px; 
    }
  
    .button-vote {
      font-size: 1rem;
      padding: 8px 15px;
      margin-bottom: 100px;
    }
  
    .card {
      padding: 15px;
    }
  
    .card textarea {
      height: 300px;
    }
  }
  

  @media (max-width: 480px) {
    body {
      padding-left: 20px;
      padding-right: 20px;
      padding-top: 250px;
      margin-bottom: 100px;
    }
  
    h1 {
      font-size: 2rem;
    }
  
    .query {
      flex-direction: column; 
      margin-bottom: 20px; 
    }
    
    .query input {
      max-width: 450px;
      width: 100%;
    }
    
    .dropdown select {
      max-width: 250px; 
      width: 100%;
      margin-bottom: 20px; 
    }
  
    .button-vote {
      font-size: 1rem;
      padding: 8px 15px;
      margin-bottom: 100px; 
    }
  
    .card {
      padding: 15px;
      margin-bottom: 20px;
    }
  
    .card textarea {
      height: 250px;
    }
  }
  
  
`, "",{"version":3,"sources":["webpack://./src/components/Arena.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;IACI,SAAS;IACT,kBAAkB;IAClB,sDAAsD;IACtD,cAAc;IACd,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,sCAAsC;IACtC,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;;IAEE,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,cAAc;EAChB;;EAEA;IACE,oCAAoC;IACpC,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,yCAAyC;EAC3C;;EAEA;IACE,oCAAoC;IACpC,YAAY;IACZ,WAAW;IACX,aAAa;IACb,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,2DAA2D;IAC3D,wCAAwC;EAC1C;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,kCAAkC;IAClC,yBAAyB;IACzB,kBAAkB;IAClB,wDAAwD;IACxD,aAAa;IACb,wCAAwC;EAC1C;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,qBAAqB;IACrB,2CAA2C;EAC7C;;EAEA;IACE,oCAAoC;IACpC,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,kCAAkC;IAClC,yBAAyB;IACzB,kBAAkB;IAClB,wDAAwD;IACxD,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,0CAA0C;EAC5C;;EAEA;IACE,oCAAoC;IACpC,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,oCAAoC;IACpC,cAAc;IACd,mBAAmB;EACrB;;EAEA,sBAAsB;EACtB;IACE;MACE,kBAAkB;MAClB,mBAAmB;MACnB,oBAAoB;IACtB;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,aAAa;IACf;;IAEA;QACI,oBAAoB;IACxB;EACF;;EAEA;IACE;MACE,kBAAkB;MAClB,mBAAmB;MACnB,kBAAkB;MAClB,oBAAoB;IACtB;;IAEA;MACE,eAAe;IACjB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;MACE,eAAe;MACf,iBAAiB;MACjB,oBAAoB;IACtB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,aAAa;IACf;EACF;;;EAGA;IACE;MACE,kBAAkB;MAClB,mBAAmB;MACnB,kBAAkB;MAClB,oBAAoB;IACtB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,sBAAsB;MACtB,mBAAmB;IACrB;;IAEA;MACE,gBAAgB;MAChB,WAAW;IACb;;IAEA;MACE,gBAAgB;MAChB,WAAW;MACX,mBAAmB;IACrB;;IAEA;MACE,eAAe;MACf,iBAAiB;MACjB,oBAAoB;IACtB;;IAEA;MACE,aAAa;MACb,mBAAmB;IACrB;;IAEA;MACE,aAAa;IACf;EACF","sourcesContent":["/* General container setup */\nbody {\n    margin: 0;\n    padding-top: 160px;\n    background: linear-gradient(to bottom, black, #126196);\n    color: #6C757D;\n    font-family: Arial, sans-serif;\n    padding-left: 130px;\n    padding-right: 130px;\n    margin-top: 50px;\n  }\n  \n  h1 {\n    font-size: 2.5rem;\n    color: #01B9F1;\n    text-align: center;\n  }\n  \n  .error-message {\n    background-color: rgba(255, 0, 0, 0.2);\n    color: red;\n    padding: 10px;\n    border-radius: 5px;\n    text-align: center;\n    margin-top: 10px;\n  }\n  \n  .form-select, \n  .form-input {\n    background-color: #f8f9fa;\n    color: #000;\n    border: none;\n    padding: 10px;\n    font-size: 1rem;\n    border-radius: 5px;\n  }\n  \n  .form-select {\n    width: 200px;\n    margin-right: 10px;\n  }\n  \n  .form-input {\n    width: 800px;\n    margin-right: 10px;\n  }\n  \n  .form-button {\n    background-color: #01B9F1;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    font-size: 1.2rem;\n    border-radius: 5px;\n    cursor: pointer;\n  }\n  \n  .form-button:hover {\n    background-color: #0288d1;\n  }\n  \n  .spinner-border {\n    width: 3rem;\n    height: 3rem;\n    border-width: 0.3rem;\n    color: #01B9F1;\n  }\n  \n  .card {\n    background-color: rgba(0, 0, 0, 0.5);\n    color: white;\n    padding: 20px;\n    border-radius: 10px;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);\n  }\n  \n  .card textarea {\n    background-color: rgba(1, 1, 1, 0.5);\n    color: white;\n    width: 100%;\n    height: 250px;\n    border: none;\n    padding: 10px;\n    border-radius: 10px;\n    resize: none;\n  }\n  \n  .card-title {\n    font-size: 1.5rem;\n    margin-bottom: 10px;\n  }\n  \n  .copy-btn {\n    background-color: #6c757d;\n    color: white;\n    border: none;\n    padding: 5px 10px;\n    border-radius: 5px;\n    cursor: pointer;\n  }\n  \n  .copy-btn:hover {\n    background-color: #5a6268;\n  }\n  \n  .vote-btn {\n    background-color: #01B9F1;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    font-size: 1.2rem;\n    margin: 5px;\n    border-radius: 5px;\n    cursor: pointer;\n  }\n  \n  .vote-btn:hover {\n    background-color: #0288d1;\n  }\n  \n  .reset-btn {\n    background-color: #6c757d;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    font-size: 1.2rem;\n    border-radius: 5px;\n    cursor: pointer;\n  }\n  \n  .reset-btn:hover {\n    background-color: #5a6268;\n  }\n  \n  .button {\n    background-color: #01B9F1; \n    color: white;\n    border: none;\n    border-radius: 5px;\n    padding: 10px 20px;\n    font-size: large;\n    cursor: pointer;\n    transition: background-color 0.3s ease, transform 0.2s ease;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);\n  }\n  \n  .button-vote{\n    border: 2px solid #01B9F1;\n    color: #01B9F1;\n    margin-bottom: 100px;\n  }\n  \n  .button-vote:hover{\n    background-color: #019FCB;\n    transform: scale(1.05); \n    border: 2px solid #019FCB;\n  }\n  \n  .button:hover {\n    background-color: #019FCB; \n    transform: scale(1.05);\n  }\n  \n  .button:active {\n    background-color: #017A9B; \n    transform: scale(0.98);\n  }\n  \n  .query {\n    display: flex;\n    justify-content: center;\n    margin-top: auto;\n  }\n  \n  .query input {\n    width: 100%;\n    max-width: 1200px;\n    padding: 12px 20px;\n    font-size: large;\n    color: white;\n    background-color: rgba(0, 0, 0, 0); \n    border: 2px solid #01B9F1; \n    border-radius: 8px;\n    transition: border-color 0.3s ease, box-shadow 0.3s ease;\n    outline: none;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\n  }\n  \n  .query input::placeholder {\n    color: rgba(255, 255, 255, 0.7); \n  }\n  \n  .query input:focus {\n    border-color: #019FCB; \n    box-shadow: 0 0 10px rgba(1, 185, 241, 0.6); \n  }\n  \n  .query input:disabled {\n    background-color: rgba(0, 0, 0, 0.2);\n    color: #6C757D;\n    cursor: not-allowed;\n  }\n  \n  .dropdown select {\n    width: 200px;\n    max-width: auto;\n    padding: 10px;\n    font-size: large;\n    color: white; \n    background-color: rgba(0, 0, 0, 0);\n    border: 2px solid #01B9F1;\n    border-radius: 8px;\n    transition: border-color 0.3s ease, box-shadow 0.3s ease;\n    outline: none;\n    appearance: none;\n    box-shadow: none;\n    cursor: pointer;    \n  }\n  \n  .dropdown select:focus {\n    border-color: #019FCB;\n    box-shadow: 0 0 5px rgba(1, 185, 241, 0.4);\n  }\n  \n  .dropdown select option {\n    background-color: rgba(0, 0, 0, 0.8); \n    color: white; \n  }\n  \n  .dropdown select option[disabled] {\n    color: #6C757D; \n  }\n  \n  .dropdown select:disabled {\n    background-color: rgba(0, 0, 0, 0.2);\n    color: #6C757D;\n    cursor: not-allowed;\n  }\n  \n  /* Responsive Styles */\n  @media (max-width: 1200px) {\n    body {\n      padding-left: 50px;\n      padding-right: 50px;\n      margin-bottom: 100px;\n    }\n  \n    .form-input {\n      width: 100%;\n    }\n  \n    .form-select {\n      width: 100%;\n    }\n  \n    .card textarea {\n      height: 400px;\n    }\n\n    .button-vote {\n        margin-bottom: 100px;\n    }\n  }\n  \n  @media (max-width: 768px) {\n    body {\n      padding-left: 30px;\n      padding-right: 30px;\n      padding-top: 250px;\n      margin-bottom: 100px;\n    }\n  \n    h1 {\n      font-size: 2rem;\n    }\n  \n    .query {\n        flex-direction: row; \n    }\n    \n    .query input {\n        max-width: 800px;\n    }\n    \n    .dropdown select {\n        max-width: 120px; \n    }\n  \n    .button-vote {\n      font-size: 1rem;\n      padding: 8px 15px;\n      margin-bottom: 100px;\n    }\n  \n    .card {\n      padding: 15px;\n    }\n  \n    .card textarea {\n      height: 300px;\n    }\n  }\n  \n\n  @media (max-width: 480px) {\n    body {\n      padding-left: 20px;\n      padding-right: 20px;\n      padding-top: 250px;\n      margin-bottom: 100px;\n    }\n  \n    h1 {\n      font-size: 2rem;\n    }\n  \n    .query {\n      flex-direction: column; \n      margin-bottom: 20px; \n    }\n    \n    .query input {\n      max-width: 450px;\n      width: 100%;\n    }\n    \n    .dropdown select {\n      max-width: 250px; \n      width: 100%;\n      margin-bottom: 20px; \n    }\n  \n    .button-vote {\n      font-size: 1rem;\n      padding: 8px 15px;\n      margin-bottom: 100px; \n    }\n  \n    .card {\n      padding: 15px;\n      margin-bottom: 20px;\n    }\n  \n    .card textarea {\n      height: 250px;\n    }\n  }\n  \n  \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
